import script from "./Maintain_MisconductCodes.vue?vue&type=script&setup=true&lang=js"
export * from "./Maintain_MisconductCodes.vue?vue&type=script&setup=true&lang=js"

import "./Maintain_MisconductCodes.vue?vue&type=style&index=0&id=2c692f16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c692f16"]])

export default __exports__